import {
  BOXCHAMP_VALIDATE_REQUEST,
  BOXCHAMP_VALIDATE_SUCCESS,
  BOXCHAMP_VALIDATE_FAILURE,
  BOXCHAMP_QUEUE_REQUEST,
  BOXCHAMP_QUEUE_COMPLETE,
  BOXCHAMP_RESET,
} from '../constants';

const initialState = {
  validating: false,
  validationResult: null,
  validationError: null,
  queuing: false,
};

export default function boxChampReducer(state = initialState, action) {
  switch (action.type) {
    case BOXCHAMP_VALIDATE_REQUEST:
      return { ...state, validating: true, validationResult: null, validationError: null };
    case BOXCHAMP_VALIDATE_SUCCESS:
      return { ...state, validating: false, validationResult: action.payload };
    case BOXCHAMP_VALIDATE_FAILURE:
      return { ...state, validating: false, validationError: action.payload };
    case BOXCHAMP_QUEUE_REQUEST:
      return { ...state, queuing: true };
    case BOXCHAMP_QUEUE_COMPLETE:
      return { ...state, queuing: false };
    case BOXCHAMP_RESET:
      return initialState;
    default:
      return state;
  }
}
